export default {
  name: 'dsa-galaxy-class',
  override: {
    KC_ESC: 'pink',
    KC_F1: 'darker-blue',
    KC_F2: 'darker-blue',
    KC_F3: 'darker-blue',
    KC_F4: 'darker-blue',
    KC_F5: 'pink',
    KC_F6: 'pink',
    KC_F7: 'pink',
    KC_F8: 'pink',
    KC_F9: 'light-blue',
    KC_F10: 'light-blue',
    KC_F11: 'light-blue',
    KC_F12: 'light-blue',
    KC_PSCR: 'purple',
    KC_SLCK: 'purple',
    KC_PAUS: 'purple',
    KC_GRV: 'mod',
    KC_GESC: 'mod',
    KC_1: 'mod',
    KC_2: 'mod',
    KC_3: 'mod',
    KC_4: 'mod',
    KC_5: 'mod',
    KC_6: 'mod',
    KC_7: 'mod',
    KC_8: 'mod',
    KC_9: 'mod',
    KC_0: 'mod',
    KC_MINS: 'mod',
    KC_EQL: 'mod',
    KC_TAB: 'purple',
    KC_BSLS: 'mod',
    KC_CAPS: 'purple',
    KC_LSFT: 'purple',
    KC_LCTL: 'purple',
    KC_LGUI: 'purple',
    KC_LALT: 'purple',
    KC_SPC: 'gray',
    KC_RALT: 'purple',
    KC_RGUI: 'purple',
    KC_INS: 'pink',
    KC_HOME: 'pink',
    KC_PGUP: 'pink',
    KC_DEL: 'pink',
    KC_END: 'pink',
    KC_PGDN: 'pink',
    KC_UP: 'darker-blue',
    KC_LEFT: 'darker-blue',
    KC_DOWN: 'darker-blue',
    KC_RGHT: 'darker-blue',
    KC_NLCK: 'mod',
    KC_PSLS: 'mod',
    KC_PAST: 'mod',
    KC_PMNS: 'mod',
    KC_PPLS: 'mod',
    KC_PENT: 'mod',
    KC_PDOT: 'pink',
    KC_P0: 'pink',
    KC_P1: 'light-blue',
    KC_P2: 'light-blue',
    KC_P3: 'light-blue',
    KC_P4: 'light-blue',
    KC_P5: 'light-blue',
    KC_P6: 'light-blue',
    KC_P7: 'light-blue',
    KC_P8: 'light-blue',
    KC_P9: 'light-blue'
  }
};
